import { EmailTemplate } from "../interfaces/emailTemplate";
import { fetchWithAuth } from "./fetchWithAuth";

const PROD_APP_URL = process.env.REACT_APP_PROD_APP_URL || "";
const API_URL = process.env.REACT_APP_API_URL || "";
const DEV_API_URL = process.env.REACT_APP_DEV_API_URL || "";
const PROD_API_URL = process.env.REACT_APP_PROD_API_URL || "";

const apiBaseUrl =
  window.location.hostname === "localhost"
    ? API_URL
    : window.location.hostname === new URL(PROD_APP_URL).hostname
      ? PROD_API_URL
      : DEV_API_URL;

export const getEmailTemplates = async (): Promise<EmailTemplate[]> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated");
  }

  const response = await fetchWithAuth(
    `${apiBaseUrl}/api/EmailTemplate/GetEmailTemplates`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) {
    throw new Error("Failed to fetch email templates");
  }

  const emailTemplates: EmailTemplate[] = await response.json();

  return emailTemplates;
};

export const updateEmailTemplate = async (
  emailTemplate: EmailTemplate,
): Promise<void> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated");
  }

  const response = await fetchWithAuth(
    `${apiBaseUrl}/api/EmailTemplate/UpdateEmailTemplate`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(emailTemplate),
    },
  );

  if (!response.ok) {
    throw new Error("Failed to update email template");
  }
};
